import React from 'react';
import { LogoFull } from '../components/Images';

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <img src={LogoFull} alt=""/>
    </div>
  );
};

export default SplashScreen;